import React, { useEffect, useState } from "react";
import Image from "next/image";
import { fetchCountryCode } from "lib/utils/getCountryCode";
import Link from "next/link";

export const PremiumCard: React.FC = () => {
  const [countryCode, setCountryCode] = useState("IN");
  useEffect(() => {
    fetchCountryCode(setCountryCode);
  }, []);
  const price = countryCode === "IN" ? "₹69" : "$9";
  return (
    <div
      className={
        "relative mt-2 box-border flex h-[209px] w-[230px] flex-col gap-2 self-center rounded-[13.625px] px-4 py-1"
      }
      style={{
        background:
          "linear-gradient(134.45deg, #EAF1FF 13.44%, #FFFFFF 27.37%, #EAF1FF 36.99%, #FFFFFF 45.96%, #EAF1FF 56.2%, #FFFFFF 67.7%, #EAF1FF 78.47%, #FFFFFF 86.2%)",
        // border: "3.2625px solid #FFFFFF",
        // borderRadius: "13.05px",
      }}
    >
      {/* Header Text */}
      <div>
        {/* <h3 className="m-0 mb-1 text-[14px] leading-[18px] font-bold text-black">
          Upgrade your resume with
        </h3> */}
        <div className="flex items-baseline gap-2">
          <span className="text-[22px] font-bold leading-[25px] text-black">
            Premium
          </span>
          <span className="text-[32px] font-bold leading-[38px] text-black">
            {price}
          </span>
          <span className="text-[14px] font-normal leading-[18px] text-black">
            Only
          </span>
        </div>
      </div>

      {/* Features List */}
      <div className="flex flex-col gap-2">
        <div className="flex items-center gap-3">
          <div className="flex h-[28px] w-[28px] items-center justify-center rounded-full border-[2px] border-black">
            <Image
              src="/icons/resume-icon.svg"
              alt="Resume"
              width={20}
              height={20}
            />
          </div>
          <div>
            <p className="m-0 text-[13px] font-semibold leading-[16px] text-black">
              Resume analysis <br /> and score check
            </p>
            {/* <p className="m-0 font-semibold text-[12px] leading-[16px] text-black">and score check</p> */}
          </div>
        </div>

        <div className="flex items-center gap-3">
          <div className="flex h-[28px] w-[28px] items-center justify-center rounded-full border-[2px] border-black">
            <Image
              src="/icons/save-icon.svg"
              alt="Save"
              width={20}
              height={20}
            />
          </div>
          <p className="m-0 text-[13px] font-semibold leading-[16px] text-black">
            Save unlimited resumes
          </p>
        </div>

        <div className="flex items-center gap-3">
          <div className="flex h-[28px] w-[28px] items-center justify-center rounded-full border-[2px] border-black">
            <Image
              src="/icons/ad-free.svg"
              alt="Ad Free"
              width={20}
              height={20}
            />
          </div>
          <p className="m-0 text-[13px] font-semibold leading-[16px] text-black">
            AD Free Experience
          </p>
        </div>
      </div>

      {/* Subscribe Button */}
      <Link  href="/premium-subscription">
        <button
          className="mt-auto w-full rounded-lg border-[3.2625px] border-solid border-white  px-2 py-1.5 text-[16px] font-bold leading-[20px]  text-[#ffffff]"
          style={{
            background:
              "linear-gradient(90deg, #5866FB 0%, #7D86E3 49%, #5865FB 100%)",
            cursor: "pointer",
          }}
        >
          Subscribe Now
        </button>
      </Link>
    </div>
  );
};
